import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import {
  getNgpSamplingAssignmentQueries,
  NgpAssignmentMapPage,
} from '@sampling';

export const Route = createFileRoute('/_app/_admin/ngp-sampling-assignment')({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(
      ctx.context.auth,
      Permission.NgpSamplingAssignment,
    );
  },
  loader: async ({ context }) => {
    const queries = getNgpSamplingAssignmentQueries();
    await context.queryClient.prefetchQuery(queries.map());
    await context.queryClient.prefetchQuery(queries.samplers());
    await context.queryClient.prefetchQuery(queries.samplerOrganizations());
  },
  component: NgpAssignmentMapPage,
});
